export default "__VITE_PUBLIC_ASSET__b015106c__"